export const dataHooks = {
  nestableListCount: 'nestableList-count',
  nestableListButton: 'nestableList-button',
};

export const DEPTH_THRESHOLD = 84;
